import React, {PropsWithChildren} from 'react';
import style from './style.module.scss';
import {TPropsWithClassName} from 'core/types';
import classNames from 'classnames';
import {TTypographyVariant, Typography} from 'components/Typography';

export type TExpertShieldSize = 'large' | 'medium' | 'small';

interface IExpertShieldOwnProps {
    size?: TExpertShieldSize;
}

type TExpertShieldProps = PropsWithChildren<TPropsWithClassName<IExpertShieldOwnProps>>;

const TYPOGRAPHY_VARIANT_BY_SIZE: Record<TExpertShieldSize, TTypographyVariant> = {
    large: 'label-14-r-fluid',
    medium: 'label-12-m',
    small: 'label-10-m-up',
};

const ExpertShield = ({children, size = 'large', className}: TExpertShieldProps) => {
    return (
        <div className={classNames(style.root, style[size], className)}>
            <Typography variant={TYPOGRAPHY_VARIANT_BY_SIZE[size]}>{children}</Typography>
        </div>
    );
};

export default ExpertShield;
